import { IApplicationState } from '../../types/redux';

export const selectServices = (state: IApplicationState) => state.services;
